import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, LoadingController, Events, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home'
import { EventosPage } from '../pages/eventos/eventos'
import { OfertasPage } from '../pages/ofertas/ofertas'

import { Autenticacao } from '../providers/autenticacao'
import { Componentes } from '../providers/componentes';

import { Storage } from '@ionic/storage';
import { JwtHelper } from 'angular2-jwt';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  loading: any;
  jwtHelper: JwtHelper = new JwtHelper();

  pages: Array<{ title: string, component: any }>;

  constructor(
    public autenticacao: Autenticacao,
    public platform: Platform,
    public loadingCtrl: LoadingController,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public componentes: Componentes,
    public events: Events,
    public menu: MenuController,
    public storage: Storage
  ) {

    this.rootPage = HomePage;

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'CARDÁPIO', component: 'CardapioPage' },
      { title: 'VINHOS', component: 'VinhosCategoriasPage' },
      { title: 'OFERTAS', component: OfertasPage },
      { title: 'EVENTOS', component: EventosPage },
      { title: 'CONTATO', component: 'ContatoPage' },
      { title: 'ENVIE SUA SUGESTÃO, ELOGIO OU RECLAMAÇÃO', component: 'SugestoesPage' }
    ];
  }

  initializeApp() {
    this.platform.ready().then(() => {

      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#5d4037');

      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);
    });
  }

  openPage(page) {
    this.nav.push(page.component);
  }

  openHome() {
    this.nav.setRoot(HomePage);
  }

  listenToLoginEvents() {
    this.events.subscribe('user:login', () => {
      this.enableMenu(true);
    });

    this.events.subscribe('user:logout', () => {
      this.enableMenu(false);
    });
  }

  enableMenu(loggedIn: boolean) {
    this.menu.enable(loggedIn, 'loggedInMenu');
    this.menu.enable(!loggedIn, 'loggedOutMenu');
  }

  login() {
    this.nav.setRoot('LoginPage');
  }

  logout() {
    this.autenticacao.logout().then(data => {
      this.componentes.apresentaToast('Logout realizado com sucesso!');
      this.nav.setRoot('LoginPage');
    }, err => {
      this.componentes.apresentaToast('Não foi possível realizar o logout. Verifique a sua conexão e tente novamente.');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts